<template>
  <div>
    <split-box>
      <template v-slot:top-content>
        <template v-if="!showInterestingAnswer">
          <div class="text-center" v-if="enableDimensionScore">
            <div class="score">
              <p>
                本次评测总得分：<span>{{ answerDimensionScore.score }}</span> 分
              </p>
            </div>
            <div class="mt-1">
              <a class="text-theme text-small leading-22" type="text" @click="showReport" v-if="!reportVisibility"
                >查看测评报告</a
              >
              <div v-else class="text-medium font-medium leading-18 theme-black-850">{{ survey.title }}</div>
            </div>
          </div>
          <div class="text-center" v-else-if="!isWait && !enableDimensionScore">
            <!-- 证书 -->
            <template
              v-if="
                enableCertificateScore &&
                overData.answerCertificate &&
                (isScoreSurvey || overData.answerCertificate.effType === 1)
              "
            >
              <certificate-info :overData="overData" :survey="survey" />
            </template>
            <!-- 考试-显示得分 -->
            <template v-else-if="isScoreSurvey && enableScoreInfo && answerId">
              <score-info />
            </template>
            <!-- 考试-普通样式 -->
            <template v-else>
              <div v-for="tip in tips" :key="tip">
                <div v-html="tip" class="text-medium"></div>
              </div>
            </template>
          </div>
          <vote-answer/>
          <AnswerAnalysis v-if="reportVisibility"></AnswerAnalysis>
        </template>
        <template v-else>
          <template v-if="isUserStory">
            <div v-if="!$bus.scoreEnd" style="height: 600px;"></div>
            <user-story v-else @share="onShare"/>
          </template>

          <interest v-else/>
        </template>
      </template>
      <template v-slot:bottom-content>
        <div v-if="answerId">
          <ul class="operate-group flex justify-between text-center" :style="operateStyle">
            <li v-if="viewableAfterSubmit" @click="onPreview">
              <div>
                <img src="~@/assets/img/svg/show-content.svg" alt="" />
              </div>
              <div class="mt-1">
                <span class="inline-block text-small">查看已填</span>
                <span class="inline-block text-small">内容</span>
              </div>
            </li>
            <li v-else-if="viewableAfterSubmitAndFollow && !followedOfficialAccount" @click="onFansPreview">
              <div :class="{ 'animate-scale': !followedOfficialAccount }">
                <show-content-svg />
              </div>
              <div class="mt-1" :class="{ 'theme-linear': !followedOfficialAccount }">
                <span class="inline-block text-small">查看已填</span>
                <span class="inline-block text-small">内容</span>
              </div>
            </li>
            <li @click="onAgain" v-if="canAnswerAgain && enableAgainBtn">
              <div>
                <img src="~@/assets/img/svg/again.svg" alt="" />
              </div>
              <div class="mt-1">
                <span class="inline-block text-small">再填</span>
                <span class="inline-block text-small">一份</span>
              </div>
            </li>
            <li @click="onShare" v-if="enableMoreShare && enableShareBtn">
              <div>
                <img src="~@/assets/img/svg/share.svg" alt="" />
              </div>
              <div class="mt-1">
                <span class="inline-block text-small">立即</span>
                <span class="inline-block text-small">分享</span>
              </div>
            </li>
            <li @click="onShowHistory" v-if="hasHistory && enableHistoryBtn">
              <div>
                <img src="~@/assets/img/svg/history.svg" alt="" />
              </div>
              <div class="mt-1">
                <span class="inline-block text-small">历史答题</span>
                <span class="inline-block text-small">记录</span>
              </div>
            </li>
            <li @click="onCopyDownloadLink" v-if="enableUserExportAnswer" id="copyDownloadLink">
              <div>
                <img src="~@/assets/img/svg/history.svg" alt="" />
              </div>
              <div class="mt-1 text-red">
                <span class="inline-block text-small">复制PDF</span>
                <span class="inline-block text-small">文件链接</span>
              </div>
            </li>
          </ul>
        </div>
      </template>
    </split-box>

    <van-popup v-model="sharePopup" round position="bottom">
      <div v-if="needLogin" class="px-5 py-2 text-theme-black-650" style="background-color: rgba(227, 65, 82, 0.1)">
        <span class="text-small">您尚未完成授权，为保证您能正常获得分享红包，请先进行微信授权，</span>
        <span class="text-theme text-small" @click="toWxAuthorization">去授权</span>
      </div>
      <div class="share-popup px-5">
        <div class="text-theme-black-450 text-center">
          <span class="text-small">{{ shareText }}</span>
        </div>
        <div class="container">
          <ul class="flex justify-between text-center">
            <li @click="onShareFriend">
              <div><img src="~@/assets/img/svg/share/weixin.svg" alt="" /></div>
              <div>
                <span class="text-small">分享给好友</span>
              </div>
            </li>
            <li @click="onShowShareHistory">
              <div><img src="~@/assets/img/svg/share/history.svg" alt="" /></div>
              <div>
                <span class="text-small">分享历史</span>
              </div>
            </li>
            <li @click="onCopyShareUrl">
              <div><img src="~@/assets/img/svg/share/copy.svg" alt="" /></div>
              <div>
                <span class="text-small">复制链接</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="line my-4"></div>
        <div class="text-center">
          <span @click="sharePopup = false">取消</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { AnswerStatus, busGetters, copyText, ErrorCode, getOfficialAccountQrcode } from 'dygc'
import SplitBox from '@/components/SplitBox'
import { createPopup } from '@/assets/js/factory'
import DefaultShareTip from '@/components/overlay/DefaultShareTip'
import WeixinShareTip from '@/components/overlay/WeixinShareTip'
import ReceiveShare from '@/components/overlay/ReceiveShare'
import OverlayHistory from '@/components/overlay/OverlayHistory'
import { Notify, Dialog } from 'vant'
import OverlayShareHistory from '@/components/overlay/OverlayShareHistory'
import AnswerAnalysis from './AnswerAnalysis'
import Interest from '@/components/end/Interest'
import ScoreInfo from '@/components/end/ScoreInfo'
import ShowContentSvg from '@/components/end/svg/ShowContentSvg'
import CertificateInfo from './CertificateInfo.vue'
import VoteAnswer from './VoteAnswer.vue'
import UserStory from './UserStory'

export default {
  name: 'EndSuccessHeader',
  components: { UserStory, VoteAnswer,ShowContentSvg, ScoreInfo, Interest, AnswerAnalysis, SplitBox, CertificateInfo },
  props: {
    tips: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sharePopup: false,
      reportVisibility: false,
      followedOfficialAccount: true // 是否关注公众号
    }
  },
  created() {
    this.init()
  },
  computed: {
    isScoreSurvey() {
      return this.$bus.isScoreSurvey
    },
    enableScoreInfo() {
      const os = this.$bus.survey.otherSetting
      return os.enableScoreInfo
    },
    enableCertificateScore() {
      const os = this.$bus.survey.otherSetting
      return os.enableCertificateScore
    },
    surveyTitle() {
      return this.$bus.survey.title
    },
    shareText() {
      return this.$answerUtil.getShareText(this.$bus)
    },
    needLogin() {
      return this.share && !this.$bus.params.accountUserId
    },
    viewableAfterSubmit() {
      return this.$bus.viewableAfterSubmit && this.$bus.answerId && (!this.viewableAfterSubmitAndFollow || this.followedOfficialAccount)
    },
    viewableAfterSubmitAndFollow() {
      return (
        this.$bus.survey.otherSetting.viewableAfterSubmitAndFollow &&
        this.$bus.answerId &&
        this.$bus.currentBrowserInfo.isWeixin
      )
    },
    isUserStory(){
      return this.$bus.survey.otherSetting.enabledUserStory
    },
    showInterestingAnswer() {
      if (!this.$bus.scoreEnd) return false
      if ([AnswerStatus.OK, AnswerStatus.PASS].includes(this.overData?.status)) {
        return this.$bus.survey.otherSetting.enableInterestingAnswer
      } else {
        return false
      }
    },
    enableShareBtn() {
      if ('enableShareBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableShareBtn
      return true
    },
    enableAgainBtn() {
      if ('enableAgainBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableAgainBtn
      return true
    },
    enableHistoryBtn() {
      if ('enableHistoryBtn' in this.$bus.survey.otherSetting) return this.$bus.survey.otherSetting.enableHistoryBtn
      return true
    },
    operateStyle(){
      return this.$bus.survey.otherSetting.operateStyle || ''
    },
    enableUserExportAnswer() {
      return this.$bus.survey.otherSetting.enableUserExportAnswer && this.answerId
    },
    ...busGetters([
      'closing',
      'overData',
      'award',
      'share',
      'enableNetManualAudit',
      'enableLuck',
      'enableMoreSurvey',
      'canAnswerAgain',
      'hasHistory',
      'enableMoreShare',
      'enableDimensionScore',
      'score',
      'isWait',
      'survey',
      'answerDimensionScore',
      'answerId'
    ])
  },
  methods: {
    onFansPreview() {
      if (this.$bus.params.isTest) {
        Notify({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      this.$bus.openLoading()
      this.getOfficialAccountQrcode(true).finally(() => {
        this.$bus.closeLoading()
      })
    },
    getOfficialAccountQrcode(toPreview = false) {
      if (this.$bus.params.isTest) return Promise.resolve()
      return getOfficialAccountQrcode(this.$bus.answerId).then(res => {
        if (res.code === ErrorCode.FansQr) {
          this.$bus.busOption.overlay({
            code: ErrorCode.FOLLOW,
            data: res.data,
            message: '只有公众号粉丝可查看已填内容'
          })
        } else {
          if (toPreview) {
            this.$router.push({
              name: 'preview',
              params: {
                id: this.$bus.answerId
              }
            })
          }
        }
        this.followedOfficialAccount = res.code === 0
      })
    },
    onCopyDownloadLink() {
      const text = `${window.location.origin}/answer/export/userGetAnswerPdfById?answerId=${this.answerId}&isShowSystem=false`

      copyText('#copyDownloadLink', text).then(() => {
        Notify({
          message: '复制成功',
          type: 'primary'
        })
      })
    },
    showReport() {
      this.reportVisibility = true
    },
    onCopyShareUrl() {
      const origin = window.location.origin
      const survey = this.$bus.survey
      const answerId = this.$bus.answerId
      if (!survey || !answerId) return
      const answerChannelId = this.$bus.channel.id
      const returnUrl = `${origin}/mobile?surveyId=${survey.id}&answerChannelId=${answerChannelId}&shareAnswerId=${answerId}`
      const url = `${origin}/award/transfer?returnUrl=${encodeURIComponent(returnUrl)}`
      window.navigator.clipboard.writeText(url)
      Notify({
        type: 'success',
        message: '复制成功'
      })
    },
    onShowHistory() {
      if (this.$bus.params.isTest) {
        Notify({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      createPopup(OverlayHistory, {
        accountUserId: this.$bus.params.accountUserId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        accountUserOpenId: this.$bus.params.accountUserOpenId,
        surveyId: this.$bus.survey.id
      })
    },
    onShowShareHistory() {
      if (this.$bus.params.isTest) {
        Notify({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      createPopup(OverlayShareHistory, {
        accountUserId: this.$bus.params.accountUserId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        surveyId: this.$bus.survey.id,
        answerId: this.$bus.answerId
      })
      this.sharePopup = false
    },
    onPreview() {
      if (this.$bus.params.isTest) {
        Notify({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      this.$router.push({
        name: 'preview',
        params: {
          id: this.$bus.answerId
        }
      })
    },
    toWxAuthorization() {
      this.$answerUtil.wxAuthorization('1')
    },
    onShareFriend() {
      this.sharePopup = false
      createPopup(WeixinShareTip)
    },
    onShare() {
      const isWx = this.$bus.currentBrowserInfo.isWeixin
      if (isWx) {
        if (this.needLogin) {
          Dialog.confirm({
            title: '微信授权提示',
            message: '为保证您能正常获得分享红包，请先进行微信授权',
            confirmButtonText: '去授权',
            cancelButtonText: '暂不授权'
          })
            .then(() => {
              this.$answerUtil.wxAuthorization('1')
            })
            .catch(() => {
              this.sharePopup = true
            })
        } else {
          this.sharePopup = true
        }

        // return
        // createPopup(WeixinShareTip)
      } else {
        if (this.$bus.params.customShare) {
          const data = {
            message: 'answerShare',
            payload: {
              surveyId: this.$bus.params.surveyId,
              answerId: this.$bus.answerId
            }
          }
          this.$answerUtil.postMessage(data)
        } else {
          if (this.$bus.share) {
            const url = this.$bus.getUrl(1)
            console.log(url)
            createPopup(ReceiveShare, {
              isTest: !!this.$bus.params.isTest,
              url
            })
          } else {
            createPopup(DefaultShareTip)
          }
        }
      }
    },
    onAgain() {
      if (!this.canAnswerAgain) return
      this.$bus.openLoading()
      this.$bus
        .refreshSurvey()
        .then(() => {
          this.$bus.closeLoading()
          this.againHandler()
        })
        .catch(() => {
          this.$bus.closeLoading()
          this.againHandler()
        })
    },
    againHandler() {
      this.$bus.isOpenReward = false
      this.$bus.scoreEnd = null
      this.$bus.answerId = null
      this.$bus.onStart(true)
    },
    onToTask() {
      window.location.replace(process.env.VUE_APP_TASK_HALL)
    },
    init() {
      if (this.viewableAfterSubmitAndFollow) {
        this.getOfficialAccountQrcode()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.score {
  p {
    @apply text-theme-black-650 text-medium;
    span {
      @apply text-theme-black-850 font-bold text-medium;
    }
  }
}
</style>
